import { Grid } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCardSkeleton from '../../components/section-card/SectionCardSkeleton'
import SearchRecordsLoading from './SearchRecordsLoading'

type Props = {
  isSingleCardPage?: boolean
}

export default function SearchRecordsCardSkeleton({ isSingleCardPage = true }: Props): JSX.Element {
  const [t] = useTranslation()

  return (
    <Grid gutters="nano">
      <SectionCardSkeleton isSingleCardPage={isSingleCardPage} heading={t('tree-person.search-records.label')}>
        <SearchRecordsLoading />
      </SectionCardSkeleton>
    </Grid>
  )
}
